/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HTTPLink
 */
export interface HTTPLink {
    /**
     * 
     * @type {string}
     * @memberof HTTPLink
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof HTTPLink
     */
    uri: string;
}

/**
 * Check if a given object implements the HTTPLink interface.
 */
export function instanceOfHTTPLink(value: object): value is HTTPLink {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('uri' in value) || value['uri'] === undefined) return false;
    return true;
}

export function HTTPLinkFromJSON(json: any): HTTPLink {
    return HTTPLinkFromJSONTyped(json, false);
}

export function HTTPLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): HTTPLink {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'uri': json['uri'],
    };
}

export function HTTPLinkToJSON(json: any): HTTPLink {
    return HTTPLinkToJSONTyped(json, false);
}

export function HTTPLinkToJSONTyped(value?: HTTPLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'uri': value['uri'],
    };
}

